/**
 *Created by jmmartinez on 12/03/2020
 * v.2.0 30/09/2020 Cambiado a framework2
 **/

import React from 'react'
import PropTypes from 'prop-types';

import {DatePicker, TimePrecision} from "@blueprintjs/datetime";
import {Classes, Position} from "@blueprintjs/core";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import {DateFormatStrings} from "./DayPickerProps"
import "../resources/css/datepicker.css"


class DateTimePicker extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            valor: props.valor,
        }
    }

    componentDidMount() {
        const {valor} = this.props;
        this.setState({valor: valor});
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if( nextProps.valor !== prevState.valor){
            newState.valor= nextProps.valor;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onChange= (datetime) => {
        const {conHora, onChange, obligatorio} = this.props;
        if (datetime){
            let mostrarHora= conHora && (typeof conHora === 'boolean' && conHora === true);
            if (!mostrarHora) {
                datetime.setHours(0);
                datetime.setMinutes(0);
                datetime.setSeconds(0);
                datetime.setMilliseconds(0);
            }
            //onChange && onChange(datetime.getTime());
            onChange && onChange(datetime);
        }
        else{
            onChange && onChange(null);
        }
    }


    render() {
        const {valor} = this.state;
        const {conHora, obligatorio} = this.props;

        let bObligatorio= Boolean(obligatorio);
        //let valorDate= valor ? new Date(valor): bObligatorio ? new Date() : null;
        ///let valorDate= valor ? valor : bObligatorio ? new Date() : null;

        let mostrarHora= (typeof conHora === 'boolean' && conHora === true);


        return(
            <DatePicker
                value={valor}
                onChange={this.onChange}
                dayPickerProps= { DateFormatStrings  }
                className="datepicker"
                highlightCurrentDay={true}
            />
        );
    }

}


DateTimePicker.propTypes = {
    id: PropTypes.string,
    conHora: PropTypes.bool,
    onChange: PropTypes.func,
    valor: PropTypes.number,
    obligatorio: PropTypes.bool,
}

export default DateTimePicker

